import { QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { useEffect, useState, type ReactNode } from 'react';
import { BrowserRouter, useNavigate } from 'react-router';
import { ConfirmProvider } from '@/components/confirm-dialog';
import { toast, Toaster } from '@/components/ui/toaster';
import { SessionProvider } from '@/features/auth/session';
import { setPolicyErrorHandler } from '@/lib/api';
import { createQueryClient } from '@/lib/query-client';
import { ThemeProvider } from '@/lib/theme';

/** Avisos globais de política do plano: conta suspensa (somente leitura), limite atingido e recurso indisponível. */
function PolicyErrorNotices() {
  const navigate = useNavigate();
  useEffect(() => {
    setPolicyErrorHandler((e) => {
      if (e.code === 'organization_suspended') {
        toast.error('Conta suspensa: somente leitura', { id: 'policy-suspended', description: 'Você pode consultar e exportar os dados, mas não alterá-los.' });
        return;
      }
      toast.error(e.message || (e.code === 'plan_limit_reached' ? 'O limite do seu plano foi atingido.' : 'Este recurso não está disponível no seu plano.'), {
        id: `policy-${e.code}`,
        action: { label: 'Ver assinatura', onClick: () => navigate('/configuracoes/assinatura') },
      });
    });
    return () => setPolicyErrorHandler(null);
  }, [navigate]);
  return null;
}

export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(createQueryClient);
  return (
    <ThemeProvider>
      <QueryClientProvider client={client}>
        <BrowserRouter>
          <NuqsAdapter>
            <SessionProvider>
              <ConfirmProvider>
                <PolicyErrorNotices />
                {children}
                <Toaster />
              </ConfirmProvider>
            </SessionProvider>
          </NuqsAdapter>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
